var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"pill",attrs:{"type":_vm.type},on:{"click":_vm.click}},[_c('span',{staticClass:"icon-before"},[_vm._t("default")],2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.btnText))]),_vm._v(" "),_c('span',{staticClass:"icon-after"},[_vm._t("icon-after")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03ff00ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/buttons/BtnPill.vue
// module id = null
// module chunks = 